import { GET_ORGANIZATION_DETAILS} from './types';


export const organizationDetailsAction = (userId, showOrganizationHeader) => dispatch => {
    dispatch({
        type: GET_ORGANIZATION_DETAILS,
        userId: userId,
        showOrganizationHeader : showOrganizationHeader,
        
    })

}